import React from 'react';
import { Spin } from 'antd';
import PropTypes from 'prop-types';
import './DashBoardPage.scss';

// This is the quicksight dashboard componentof the dashboard page
function QuicksightPage({ quickSightLoading, quickSightData }) {
  return (
    <Spin spinning={quickSightLoading}>
      <div className="quicksight-page">
        {quickSightData && (
          <iframe
            src={quickSightData}
            className="quicksight-iframe"
            title="quicksight dashboard for gokwkik"
            allowfullscreen
          />
        )}
      </div>
    </Spin>
  );
}

QuicksightPage.propTypes = {
  quickSightLoading: PropTypes.bool.isRequired,
  quickSightData: PropTypes.instanceOf(String).isRequired
};
export default QuicksightPage;
